export default {
  title: 'History of Activities',
  'counter.text': 'Registers found',
  'menu.publicToken': 'Public token',
  'menu.routines': 'Routines',
  'actions.viewPdf': 'View PDF report',
  'actions.copyLink': 'Copy public link',
  'actions.linkCopied': 'Link copied!',
  'actions.linkCopyError': 'Failed to copy the link'
}
